import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class RestauranteService {
  async getMesas(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return await fetchWrapper.get(
      `${ruta}/restaurante/mesas${queryParams ? `?${queryParams}` : ""}`,
    );
  }
  async getMesa(id) {
    return await fetchWrapper.get(`${ruta}/restaurante/mesas/${id}`);
  }
  async crearMesa(datos) {
    return await fetchWrapper.post(`${ruta}/restaurante/mesas`, datos);
  }
  async actualizarMesa(id, datos) {
    return await fetchWrapper.put(`${ruta}/restaurante/mesas/${id}`, datos);
  }
  async eliminarMesa(id) {
    return await fetchWrapper.delete(`${ruta}/restaurante/mesas/${id}`);
  }
  async cambiarEstadoMesa(id, datos) {
    return await fetchWrapper.patch(
      `${ruta}/restaurante/mesas/${id}/estado`,
      datos,
    );
  }

  async getPedidos(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return await fetchWrapper.get(
      `${ruta}/restaurante/pedidos${queryParams ? `?${queryParams}` : ""}`,
    );
  }
  async getPedido(id) {
    return await fetchWrapper.get(`${ruta}/restaurante/pedidos/${id}`);
  }
  async crearPedido(datos) {
    return await fetchWrapper.post(`${ruta}/restaurante/pedidos`, datos);
  }
  async agregarItemPedido(pedidoId, datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/pedidos/${pedidoId}/agregar-item`,
      datos,
    );
  }
  async eliminarItemPedido(itemId) {
    return await fetchWrapper.delete(
      `${ruta}/restaurante/pedido-items/${itemId}`,
    );
  }
  async cerrarMesa(mesaId, datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/cerrar-mesa/${mesaId}`,
      datos,
    );
  }
  async cancelarPedido(pedidoId) {
    return await fetchWrapper.delete(`${ruta}/restaurante/pedidos/${pedidoId}`);
  }
  async actualizarClientePedido(pedidoId, clienteId) {
    return await fetchWrapper.put(
      `${ruta}/restaurante/pedidos/${pedidoId}/cliente`,
      { cliente_id: clienteId },
    );
  }

  async getProductosMenu(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return await fetchWrapper.get(
      `${ruta}/restaurante/productos-menu${
        queryParams ? `?${queryParams}` : ""
      }`,
    );
  }

  async getPedidosCocina() {
    return await fetchWrapper.get(`${ruta}/restaurante/cocina`);
  }
  async cambiarEstadoItemCocina(itemId, estado) {
    return await fetchWrapper.patch(
      `${ruta}/restaurante/cocina/item/${itemId}/estado`,
      { estado },
    );
  }
  async cambiarEstadoCocina(pedidoId, estado) {
    return await fetchWrapper.patch(
      `${ruta}/restaurante/cocina/pedido/${pedidoId}/estado`,
      { estado },
    );
  }
  async marcarPedidoListo(pedidoId) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/cocina/pedido/${pedidoId}/marcar-listo`,
    );
  }
  async actualizarNotaItem(itemId, nota) {
    return await fetchWrapper.put(
      `${ruta}/restaurante/pedido-items/${itemId}/nota`,
      { nota_cocina: nota },
    );
  }
  async actualizarObservacionesPedido(pedidoId, observaciones) {
    return await fetchWrapper.put(
      `${ruta}/restaurante/pedidos/${pedidoId}/observaciones`,
      { observaciones },
    );
  }

  // PARA LLEVAR
  async listarPedidosParaLlevar() {
    return await fetchWrapper.get(`${ruta}/restaurante/para-llevar`);
  }

  async crearPedidoParaLlevar(datos) {
    return await fetchWrapper.post(`${ruta}/restaurante/para-llevar`, datos);
  }

  async cerrarPedidoParaLlevar(pedidoId, datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/cerrar-pedido/${pedidoId}`,
      datos,
    );
  }

  async cambiarEstadoTicket(pedidoId, estado) {
    return await fetchWrapper.put(
      `${ruta}/restaurante/para-llevar/${pedidoId}/estado`,
      { estado },
    );
  }

  async marcarEntregado(pedidoId, datos = {}) {
    return await fetchWrapper.put(
      `${ruta}/restaurante/para-llevar/${pedidoId}/entregar`,
      datos,
    );
  }

  async cobrarPedidoParaLlevar(pedidoId, datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/para-llevar/${pedidoId}/cobrar`,
      datos,
    );
  }

  async cambiarEstadoPedido(pedidoId, estado) {
    if (estado === 5) {
      return await this.cerrarPedidoParaLlevar(pedidoId, {
        metodo_pago: "efectivo",
      });
    }

    return await fetchWrapper.put(
      `${ruta}/restaurante/para-llevar/${pedidoId}/estado`,
      { estado },
    );
  }

  async liberarMesa(mesaId) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/liberar-mesa/${mesaId}`,
    );
  }

  // NUEVO: Reabrir mesa
  async reabrirMesa(mesaId) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/reabrir-mesa/${mesaId}`,
    );
  }

  // NUEVO: Yango
  async crearPedidoYango(datos) {
    return await fetchWrapper.post(`${ruta}/restaurante/yango`, datos);
  }

  async cobrarPedidoYango(pedidoId, datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/yango/${pedidoId}/cobrar`,
      datos,
    );
  }

  async datos_necesarios_reporte() {
    return await fetchWrapper.get(
      `${ruta}/restaurante/datos-necesarios-reporte`,
    );
  }

  async filtrarPedidos(datos) {
    return await fetchWrapper.post(`${ruta}/restaurante/filtros_pedido`, datos);
  }

  async obtenerDetallesPedido(id) {
    return await fetchWrapper.get(`${ruta}/restaurante/pedidos/${id}/detalles`);
  }

  async exportarPedidos(datos) {
    return await fetchWrapper.postWithBlob(
      `${ruta}/restaurante/pedidos-export`,
      datos,
    );
  }

  async imprimirPDFPedidos(datos) {
    return await fetchWrapper.postPdf(
      `${ruta}/restaurante/pedidos/imprimir-pdf`,
      datos,
    );
  }
  async guardarOrdenVisual(datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/mesas/orden-visual`,
      datos,
    );
  }
  async guardarPosicionesVisual(datos) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/mesas/posiciones-visual`,
      datos,
    );
  }
  async getPendientesMesa() {
    return await fetchWrapper.get(`${ruta}/restaurante/pedidos-sin-mesa`);
  }

  async asignarMesaPedido(pedidoId, mesaId) {
    return await fetchWrapper.post(
      `${ruta}/restaurante/pedidos/${pedidoId}/asignar-mesa`,
      { mesa_id: mesaId },
    );
  }
}
